module.exports = __webpack_public_path__ + "static/media/RepiCzWhite.ae5ba5bc.svg";